import TweenLite from '../../../../node_modules/gsap/src/uncompressed/TweenLite'

import '../../../../node_modules/gsap/src/uncompressed/plugins/ScrollToPlugin'

import jQuery from '../../vendor/jquery'

var scroller = document.querySelectorAll('.js-scroller');

for ( var i = 0; i < scroller.length; i++ ) {
    var obj = scroller[ i ];

    obj.addEventListener('click', function(e) {
        e.preventDefault();
        var targetOffset = jQuery(e.target.hash).offset().top

        TweenLite.to(window, 0.2, {
            scrollTo: {
                y: targetOffset
            }
        })
    })
}